var BlsLazyloadImg = (function () {
  function clearLoadingState(root) {
    root = root && root.querySelectorAll ? root : document;
    root.querySelectorAll(".bls-loading-image, .bls-image-js img").forEach(function (node) {
      node.classList.remove("bls-loading-image");
      node.closest("motion-element")?.classList.remove("bls-loading-image");
    });
  }

  return {
    init: function (root) {
      this.lazyReady(root || document);
    },
    lazyReady: function (root) {
      /* VSKLO: keep the legacy document lifecycle for the initial page pass,
         but allow AJAX-rendered sections to refresh only their own subtree. */
      var scope = root && root.querySelectorAll ? root : document;
      clearLoadingState(scope);
      if (scope !== document) return;
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () { clearLoadingState(document); }, { once: true });
      }
      window.addEventListener("load", function () { clearLoadingState(document); }, { once: true });
    },
  };
})();

(function scheduleInitialLazyImageCleanup() {
  function run() {
    if (window.BlsLazyloadImg && typeof window.BlsLazyloadImg.init === 'function') {
      window.BlsLazyloadImg.init(document);
    } else if (typeof BlsLazyloadImg !== 'undefined' && BlsLazyloadImg && typeof BlsLazyloadImg.init === 'function') {
      BlsLazyloadImg.init(document);
    }
  }

  var homepage = !!(document.body && document.body.classList.contains('index'));
  if (!homepage) {
    run();
    return;
  }

  function schedule() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 1800 });
    } else {
      window.setTimeout(run, 700);
    }
  }

  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
class SlideSection extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.init();
  }

  async init() {
    /* VSKLO performance: keep hidden minicart recommendations completely dormant
       until the desktop drawer is actually opened. */
    const minicart = this.closest?.("#minicart_wrapper");
    if (minicart) {
      const drawer = minicart.querySelector(".minicart__wrapper");
      const minicartOpen =
        minicart.classList.contains("open") ||
        drawer?.classList.contains("open") ||
        document.documentElement.classList.contains("open-minicart");
      const recommendationHost = this.closest?.(
        "minicart-recommendations, minicart-recommendations-beside"
      );
      const recommendationsReady =
        !recommendationHost ||
        recommendationHost.dataset.vskloFetchComplete === "true";

      if (!minicartOpen || !recommendationsReady) {
        this.dataset.vskloSwiperDeferred = "true";
        return;
      }
      delete this.dataset.vskloSwiperDeferred;
    }

    if (this.globalSlide && !this.globalSlide.destroyed) return;

    /* VSKLO performance: Swiper is route/component loaded. Wait for it only when this custom element exists. */
    if (!window.Swiper && window.vskloEnsureSwiper) {
      try {
        await window.vskloEnsureSwiper();
      } catch (error) {
        console.error('[VSKLO] Swiper runtime failed to load:', error);
        return;
      }
    }
    if (!window.Swiper || !this.isConnected) return;
    this.initSlide();
  }

  initSlide() {
    const _this = this;
    var autoplaying = _this?.dataset.autoplay === "true";
    const requestedLoop = _this?.dataset.loop === "true";
    // Bestsellers and Collection Set share the same Swiper interaction contract.
    // Other carousels retain their existing gallery, product and video behavior.
    const isVskloBestsellers = _this.classList.contains("bestsellers-swiper");
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === "true";
    const autoItem = _this?.dataset.itemMobile === "true";
    const autoHeight = _this?.dataset.autoHeight === "true";
    const paginationCustom = _this?.dataset.customPagination;
    const slideShow = _this?.dataset.slideshow === "true";
    const revealSlideshow = _this?.dataset.revealSlideshow === "true";
    const customNavigation = _this?.dataset.customNavigation === "true";
    const customPrev = _this?.dataset.customPrev;
    const customNext = _this?.dataset.customNext;
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    // Infinite navigation must adapt to the actual dynamic collection size.
    // Swiper 11 needs more unique slides than the maximum visible at once.
    // For 3-7 distinct products mirror the finite display set, otherwise
    // Swiper loopFix can leave the right-side peek empty at the boundary.
    // Adapt visible cards instead of falling back to visible rewind.
    const swiperWrapper = _this.querySelector(".swiper-wrapper");
    if (isVskloBestsellers) {
      // Native HTML drag and image selection compete with Swiper's gesture.
      _this.querySelectorAll(".swiper-slide a, .swiper-slide img").forEach((element) => {
        element.draggable = false;
      });
      _this.addEventListener("dragstart", (event) => {
        if (event.target.closest?.(".swiper-slide")) event.preventDefault();
      }, { capture: true });
    }
    // Remove loop mirrors left by an editor/section reinitialization.
    swiperWrapper?.querySelectorAll(":scope > [data-vsklo-loop-mirror]").forEach((slide) => slide.remove());
    const originalSlides = swiperWrapper
      ? Array.from(swiperWrapper.children).filter((slide) => slide.classList.contains("swiper-slide"))
      : [];
    const actualSlideCount = originalSlides.length;
    const rowCount = Math.max(1, Math.floor(Number(row) || 1));
    const needsLoopMirrors = isVskloBestsellers && requestedLoop && rowCount === 1 &&
      !autoItem && actualSlideCount >= 3 && actualSlideCount <= 7;
    if (needsLoopMirrors) {
      // Swiper 11 reorders existing DOM nodes for loopFix. A small collection
      // cannot fill both sides with unique nodes, so duplicate only the visible
      // carousel's DOM cards (never Shopify products/cart records).
      const target = Math.ceil(Math.max(8, actualSlideCount * 2) / actualSlideCount) * actualSlideCount;
      originalSlides.forEach((slide, index) => {
        slide.dataset.vskloOriginalIndex = String(index);
      });
      for (let index = actualSlideCount; index < target; index += 1) {
        const origin = originalSlides[index % actualSlideCount];
        const mirror = origin.cloneNode(true);
        mirror.dataset.vskloLoopMirror = "true";
        mirror.dataset.vskloOriginalIndex = String(index % actualSlideCount);
        // Repeated HTML IDs inside slides would break document-wide selectors.
        if (mirror.id) mirror.removeAttribute("id");
        mirror.querySelectorAll("[id]").forEach((node) => node.removeAttribute("id"));
        mirror.querySelectorAll("a,img").forEach((node) => { node.draggable = false; });
        swiperWrapper.appendChild(mirror);
      }
    }
    const renderedSlideCount = swiperWrapper
      ? Array.from(swiperWrapper.children).filter((slide) => slide.classList.contains("swiper-slide")).length
      : 0;
    const canAdaptLoop = requestedLoop && rowCount === 1 && !autoItem && actualSlideCount >= 3;
    // Centered fractional Swiper views need an odd number of FULL cards. For
    // 3 items show 1 + peeks; 4 items show 1 + wider peeks; 5 allow 3 + peeks.
    const maxLoopView = actualSlideCount <= 3 ? 1.6 : actualSlideCount === 4 ? 2.6 : 3.6;
    const capVisible = (value) => {
      const count = Number.parseFloat(value);
      return canAdaptLoop && Number.isFinite(count) ? Math.min(count, maxLoopView) : value;
    };
    const visibleMobile = capVisible(itemMobile);
    const visibleTablet = capVisible(itemTablet);
    const visibleDesktop = capVisible(itemDesktop);
    const largestView = Math.max(
      1,
      Number.parseFloat(visibleMobile) || 1,
      Number.parseFloat(visibleTablet) || 1,
      Number.parseFloat(visibleDesktop) || 1
    );
    const loop = requestedLoop && actualSlideCount > 1 &&
      renderedSlideCount >= rowCount * (Math.ceil(largestView) + 1);
    // Only 2 distinct slides or complex multi-row/auto layouts get rewind;
    // a single item stays static and does not advertise circular navigation.
    const rewind = requestedLoop && !loop && actualSlideCount > 1;
    _this.dataset.vskloLoopMode = loop ? "loop" : rewind ? "rewind" : "static";

    const navigationPrevious = customNavigation
      ? document.querySelector(`.${customPrev}`)
      : _this.querySelector(".swiper-button-prev");
    const navigationNext = customNavigation
      ? document.querySelector(`.${customNext}`)
      : _this.querySelector(".swiper-button-next");
    const navigationControls = navigationPrevious?.closest("[data-vsklo-carousel-controls]");
    function updateNavigationStatus(swiper) {
      if (!navigationControls || !swiper || swiper.destroyed) return;
      const current = navigationControls.querySelector("[data-vsklo-carousel-current]");
      const total = navigationControls.querySelector("[data-vsklo-carousel-total]");
      const active = swiper.slides?.[swiper.activeIndex];
      const semanticIndex = Number(active?.dataset.vskloOriginalIndex);
      const index = needsLoopMirrors && Number.isFinite(semanticIndex)
        ? semanticIndex : (Number(swiper.realIndex) || 0);
      if (current) current.textContent = String((index % Math.max(1, actualSlideCount)) + 1).padStart(2, "0");
      if (total) total.textContent = String(actualSlideCount).padStart(2, "0");
      navigationControls.dataset.vskloCarouselReady = actualSlideCount > 1 ? "true" : "single";
      if (actualSlideCount <= 1) {
        if (navigationPrevious) navigationPrevious.disabled = true;
        if (navigationNext) navigationNext.disabled = true;
      }
    }

    if (direction == "vertical") {
      _this.style.maxHeight = _this.offsetHeight + "px";
    }
    this.globalSlide = new Swiper(_this, {
      slidesPerView: autoItem ? "auto" : visibleMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      rewind: rewind,
      effect: effect,
      autoHeight: autoHeight,
      speed: isVskloBestsellers && window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : speed,
      // Swiper follows the finger immediately, without a second competing
      // mouse/touch handler; catalog uses equivalent low-latency settings.
      ...(isVskloBestsellers ? {
        touchStartPreventDefault: true,
        threshold: 2,
        followFinger: true,
        longSwipes: true,
        shortSwipes: true,
        longSwipesRatio: 0.18,
        loopPreventsSliding: true,
        preventClicks: true,
        preventClicksPropagation: true
      } : {}),
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      centeredSlides: isVskloBestsellers && actualSlideCount > 2,
      grabCursor: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: navigationNext,
        prevEl: navigationPrevious,
      },
      pagination: {
        clickable: true,
        el: paginationCustom == undefined ? 
          _this.querySelector(".parent-pagination") ||
          _this.querySelector(".swiper-pagination") : _this.querySelector(`.${paginationCustom}`),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: visibleTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
          type: progressbar ? "progressbar" : "bullets",
          autoHeight: false,
          centeredSlides: isVskloBestsellers && actualSlideCount > 2
        },
        1025: {
          slidesPerView: visibleDesktop,
          spaceBetween: spacing,
          type: progressbar ? "progressbar" : "bullets",
          autoHeight: false,
          centeredSlides: isVskloBestsellers && actualSlideCount > 2
            ? true : (slideShow && itemDesktop == 1.5 ? true : false),
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          updateNavigationStatus(e);
          e.autoplay.stop();
          if (_this?.dataset.autoplay === "true") {
            Motion.inView(
              _this,
              async () => {
                e.autoplay.start();
              },
              { margin: "0px 0px -50px 0px" }
            );
          }

          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
          var video = _this.querySelector("video.slideshow");
          if (video) {
            const handleIntersection = (entries, observer) => {
              if (!entries[0].isIntersecting) return;
              observer.unobserve(_this);
              const videos = _this.querySelectorAll("video");
              videos.forEach((video) => {
                const dataSrc = video.dataset.src;
                if (dataSrc) {
                  video.src = dataSrc;
                  video.removeAttribute("data-src");
                }
              });
            };
            new IntersectionObserver(handleIntersection.bind(_this), {
              rootMargin: "0px 0px 200px 0px",
            }).observe(_this);
          }
        },
        realIndexChange: function (swiper) {
          updateNavigationStatus(swiper);
        },
        resize: function (swiper) {
          updateNavigationStatus(swiper);
        },
        slideChangeTransitionStart: function () {
          if (!slideShow) return;
          const currentSlide = this.slides && this.slides[this.activeIndex];
          if (!currentSlide) return;
          currentSlide
            .querySelectorAll("motion-element")
            .forEach(async (motion) => {
              if (motion && typeof motion.preInitialize === "function") {
                await motion.preInitialize();
              }
            });
        },
        slideChangeTransitionEnd: function () {
          if (!slideShow) return;
          const currentSlide = this.slides && this.slides[this.activeIndex];
          if (!currentSlide) return;
          currentSlide
            .querySelectorAll("motion-element")
            .forEach(async (motion) => {
              if (!motion) return;
              motion.classList.remove("animate-delay");
              if (typeof motion.initialize === "function") {
                await motion.initialize();
              } else {
                motion.classList.remove("invisible");
              }
            });
        },
        touchMove: function (swiper, event) {
          const innerWidth = event?.view?.innerWidth ?? window.innerWidth;
          const swiperMedia = swiper.el.classList.contains('swiper-popup-media');
          const slidePopup = document.querySelector("slide-section-popup");
          if (slidePopup && swiperMedia && innerWidth > 767) {
            slidePopup.swiper.allowTouchMove = false;
            slidePopup.swiper.unsetGrabCursor();
          }
        },
        touchEnd: function (swiper, event) {
          const innerWidth = event?.view?.innerWidth ?? window.innerWidth;
          const swiperMedia = swiper.el.classList.contains('swiper-popup-media');
          const slidePopup = document.querySelector("slide-section-popup");
          if (!swiperMedia) return;
          if (slidePopup && innerWidth > 767) {
            slidePopup.swiper.allowTouchMove = true;
            slidePopup.swiper.setGrabCursor();
          }
        }
      },
    });
  }


}
customElements.define("slide-section", SlideSection);

class PopupBase extends HTMLElement {
  constructor() {
    super();
    this.customClass = this.dataset.customClass;
    this.modal = null;
  }

  async initPopup(content, text, customClass, modalWidth) {
    if (!window.tingle && window.vskloEnsureTingle) {
      try {
        await window.vskloEnsureTingle();
      } catch (error) {
        console.error('[VSKLO] Popup runtime failed to load:', error);
        return;
      }
    }
    if (!window.tingle || !window.tingle.modal) return;
    const _this = this;
    window.__VSKLO_TINGLE_OVERLAY_SEQ__ = Number(window.__VSKLO_TINGLE_OVERLAY_SEQ__ || 0);
    const overlayOwner = `tingle-popup-${++window.__VSKLO_TINGLE_OVERLAY_SEQ__}`;
    this.modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ["overlay", "button", "escape"],
      cssClass: [this.customClass || customClass],
      onOpen: function () {
        const modalBoxContent = this.modal.querySelector(".tingle-modal-box");
        if (modalWidth) {
          modalBoxContent.style.setProperty("--popup-max-width", modalWidth);
        }
        document.dispatchEvent(new CustomEvent("modal:opened"));
        if (window.VSKLOOverlayState) window.VSKLOOverlayState.acquire(overlayOwner);
        else document.documentElement.classList.add("open-popup");
        root.style.setProperty(
          "padding-right",
          getScrollBarWidth.init() + "px"
        );
        const video = this.modalBox.querySelector("video");
        if (!video) return;
        video.play();
        if (this.modal.classList.contains("shopable-video")) {
          video.muted = false;
        }
      },
      onClose: function () {
        document.dispatchEvent(new CustomEvent("modal:closed"));
        if (window.VSKLOOverlayState) window.VSKLOOverlayState.release(overlayOwner);
        else document.documentElement.classList.remove("open-popup");
        if (window.VSKLOCleanupSharedDrawerShell) window.VSKLOCleanupSharedDrawerShell();
        else root.style.removeProperty("padding-right");
      },
      beforeClose: function () {
        _this.onCloseEvent();
        if (window.VSKLOOverlayState) window.VSKLOOverlayState.release(overlayOwner);
        else document.documentElement.classList.remove("open-popup");
        if (window.VSKLOCleanupSharedDrawerShell) window.VSKLOCleanupSharedDrawerShell();
        else root.style.removeProperty("padding-right");
        return true;
      },
    });
    this.modal.setHeader = function (content) {
      let popup_content = this.modalBoxContent;
      let popup_header = document.createElement("div");
      popup_header.classList.add("tingle-modal-box__header");
      popup_header.innerHTML = content;
      let parentElement = popup_content.parentNode;
      parentElement.insertBefore(popup_header, popup_content);
    };
    if (text) {
      this.modal.setHeader(text);
    }

    this.modal.setContent(content);
    this.modal.open();
  }

  onClose() {
    this.modal.close();
  }
  onCloseEvent() {}
}
window.VSKLOPopupBase = PopupBase;

class SwatchInit extends HTMLElement {
  constructor() {
    super();
    this.options = null;
    this._vskloSwatchInitBound = false;
    this._vskloSwatchInitScheduled = false;
  }

  connectedCallback() {
    if (this._vskloSwatchInitBound || this._vskloSwatchInitScheduled) return;

    this._vskloSwatchInitScheduled = true;
    window.requestAnimationFrame(() => {
      this._vskloSwatchInitScheduled = false;
      if (!this.isConnected || this._vskloSwatchInitBound) return;
      this.init();
      this._vskloSwatchInitBound = true;
    });
  }

  init() {
    const _this = this;
    this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
      _this.checkSwatches(btn);
    });
  }
  checkSwatches(e) {
    const { color, image, customValue, swatchType, optionSwatchValue } =
      e.dataset;
    if (color) {
      if (swatchType != "variant_images") {
        if (optionSwatchValue.length == 0 || optionSwatchValue == null) {
          if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
            if (image) {
              e.classList.add("color__" + color.replace(" ", "-"));
              e.style.backgroundColor = null;
              e.style.backgroundImage = "url('" + image + "')";
              e.style.backgroundSize = "cover";
              e.style.backgroundRepeat = "no-repeat";
            }
          }
        } else {
          e.style.setProperty("--swatch--background", optionSwatchValue);
        }
      } else {
        if (optionSwatchValue == null || optionSwatchValue.length == 0) {
          if (image) {
            e.classList.add("color__" + color.replace(" ", "-"));
            e.style.backgroundColor = null;
            e.style.backgroundImage = "url('" + image + "')";
            e.style.backgroundSize = "cover";
            e.style.backgroundRepeat = "no-repeat";
          } else if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
          }
        } else {
          e.style.setProperty("--swatch--background", optionSwatchValue);
        }
      }
    }
  }
  checkColor(strColor) {
    var s = new Option().style;
    s.color = strColor;
    return s.color == strColor;
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll(".product__color-swatches--js.active"),
      (select) => select.getAttribute("data-value")
    );
    this.variantData.find((variant) => {
      if (this.options.length == 1) {
        const variantOptions = {
          1: variant.option1,
          2: variant.option2,
          3: variant.option3,
        };
        if (variantOptions[this.position_swatch] === this.options[0]) {
          this.options = variant.options;
        }
      }
    });
  }
  updateMasterId(variantData) {
    return (this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    }));
  }
}

// js for 3d product - not done yet
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        deferredElement.play();
      }
    }
  }
}

function handleErrorMessagePopup(errorMessage = false) {
  const message = String(errorMessage || window.cartStrings?.error || "Could not complete this action");
  const url = `${window.location.pathname}?section_id=form-message`;
  return fetch(url, {
    credentials: "same-origin",
    headers: { "X-Requested-With": "XMLHttpRequest" }
  })
    .then((response) => {
      if (!response.ok) throw new Error("Error message request failed: " + response.status);
      return response.text();
    })
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const wrapper = html.querySelector(".product-form__error-message-wrapper");
      const node = wrapper?.querySelector(".product-form__error-message");
      if (!wrapper || !node) throw new Error("Error message markup missing");
      node.textContent = message;
      showToast(wrapper.innerHTML, 5000, "modal-error");
    })
    .catch((error) => {
      console.error("[VSKLO] Error message presentation failed:", error);
      if (typeof showToast === "function") showToast(message, 5000, "modal-error");
    });
}

function showToast(message, duration = 3000, customClass = "") {
  let toastContainer = document.getElementById("toast-container");
  if (!toastContainer) {
    toastContainer = document.createElement("div");
    toastContainer.id = "toast-container";
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement("div");
  toast.className = `toast show ${customClass}`;
  toast.innerHTML = message;
  toastContainer.appendChild(toast);

  Motion.animate(
    toast,
    {
      opacity: [0, 1],
      scale: [0.3, 1],
    },
    {
      duration: 0.3,
      easing: "ease-out",
    }
  );

  setTimeout(() => {
    closeToast(toast);
  }, duration);
}

function closeToast(toast) {
  Motion.animate(
    toast,
    { opacity: 0, scale: 0.5 },
    { duration: 0.2, easing: "ease-in" }
  ).then(() => {
    toast.remove();
  });
}

// js for copy button
class CopyButton extends HTMLElement {
  constructor() {
    super();
    this.content = this.dataset.content;
    this.init();
  }
  init() {
    if (this.content) {
      this.addEventListener("click", this.onClick.bind(this));
    }
  }
  onClick() {
    navigator.clipboard.writeText(this.content);
    this.classList.add("copied");
  }
  updateUrl(newContent) {
    this.content = newContent;
  }
}
customElements.define("copy-button", CopyButton);
